import Dashboard from "views/Dashboard.js";
// import Notifications from "views/Notifications.js";
import Slider from "views/Slider";
import About from "views/About";
import HomePage from "views/HomePage";
import HomeVideo from "views/HomeVideo";
// import Maps from "views/Map.js";
// import UserPage from "views/User.js";
import Qr_code from "views/Qr_code";
import WalkThrough from "views/WalkThrough";
import Gallery from "views/Gallery";
import Announcements from "views/Announcements";
// import AddAdmin from "views/AddAdmin"
import TankShop from "views/TankShop";
import PrivacyPolicies from "views/PrivacyPolicies";
import Terms from "views/Terms";
import Users from "views/Users";
// import SocialMedia from "views/SocialMedia";
import Events from "views/Events";
import GameAdmin from "views/GameAdmin";
import GameLevels from "views/GameLevels";
import GameHallOrder from "views/GameHallOrder";
import GameRules from "views/GameRules";
import GameDrawsWinners from "views/GameDrawsWinners";
import GameStats from "views/GameStats";
import GameExports from "views/GameExports";
import Adduser from "views/Adduser";
import Notification from "views/Notification";
import IconsSocialMedia from "views/IconsSocialMedia";
import Contact from "views/Contact";
import {
  ROLE_ADMIN,
  ROLE_QUESTION_EDITOR,
  ROLE_SUPERADMIN,
  normalizeRole,
} from "config/roles";

// function PrivateRoute({ element }) {
//   const token = localStorage.getItem('token');
//   const userRole = localStorage.getItem('userRole');

//   if (!token) {
//     return <Navigate to="/" replace />;
//   }

//    // Check if the user has role "0"
//    if (userRole === '0') {
//     // If the user has role "0," block access to "User Management" and "UserPage"
//     if (element.props.path === '/user-management' || element.props.path === '/UserPage') {
//       return <Navigate to="/" replace />;
//     }
//   }

//   return <Route element={element} />;
// }


const allRoutes = [
  {
    path: "/dashboard",
    name: "Dashboard",
    icon: "nc-icon nc-bank",
    component: (
    <Dashboard />
    ),
    layout: "/admin",
  },
  {
    path: "/Banner",
    name: "Banner",
    icon: "nc-icon nc-image",
    component: <Slider />,
    layout: "/admin",

  },
  {
    path: "/HomePage",
    name: "Home Page",
    icon: "nc-icon nc-layout-11",
    component: <HomePage />,
    layout: "/admin",

  },
  {
    path: "/HomeVideo",
    name: "Intro Video",
    icon: "nc-icon nc-button-play",
    component: <HomeVideo />,
    layout: "/admin",
  },
  // {
  //   path: "/maps",
  //   name: "Maps",
  //   icon: "nc-icon nc-pin-3",
  //   component: <Maps />,
  //   layout: "/admin",
  // },
  // {
  //   path: "/notifications",
  //   name: "Notifications",
  //   icon: "nc-icon nc-bell-55",
  //   component: <Notifications />,
  //   layout: "/admin",
  // },
  // {
  //   path: "/admin",
  //   name: "Add Admin",
  //   icon: "nc-icon nc-single-02",
  //   component: <AddAdmin />,
  //   layout: "/admin",
  // },
  // {
  //   path: "/login",
  //   name: "Login",
  //   icon: "nc-icon nc-single-02",
  //   component: <Login/>,
  //   layout: "/",
  // },
  {
    path: "/events",
    name: "Events",
    icon: "nc-icon nc-calendar-60",
    component: <Events />,
    layout: "/admin",

  },
  {
    path: "/Exhibition",
    name: "Exhibition",
    icon: "nc-icon nc-album-2",
    component: <Gallery />,
    layout: "/admin",

  },
  {
    path: "/Announcements",
    name: "Announcements",
    icon: "nc-icon nc-single-copy-04",
    component: <Announcements />,
    layout: "/admin",
  },
  {
    path: "/TankShop",
    name: "Tank Shop",
    icon: "nc-icon nc-delivery-fast",
    component: <TankShop />,
    layout: "/admin",

  },
  {
    path: "/SocialMedia",
    name: "Social Media",
    icon: "nc-icon nc-chat-33",
    component: <IconsSocialMedia />,
    layout: "/admin",
  },
  {
    path: "/contact",
    name: "Contact",
    icon: "nc-icon nc-mobile",
    component: <Contact />,
    layout: "/admin",
  },
  {
    path: "/game-levels",
    name: "Game Levels",
    icon: "nc-icon nc-settings",
    component: <GameLevels />,
    layout: "/admin",
  },
  {
    path: "/game-halls",
    name: "Game Hall Order",
    icon: "nc-icon nc-bulb-63",
    component: <GameHallOrder />,
    layout: "/admin",
  },
  {
    path: "/game-rules",
    name: "Game Rules",
    icon: "nc-icon nc-book-bookmark",
    component: <GameRules />,
    layout: "/admin",
  },
  {
    path: "/questions",
    name: "Questions Game",
    icon: "nc-icon nc-controller-modern",
    component: <GameAdmin />,
    layout: "/admin",

  },
  {
    path: "/game-draws-winners",
    name: "Game Draw & Winners",
    icon: "nc-icon nc-trophy",
    component: <GameDrawsWinners />,
    layout: "/admin",
  },
  {
    path: "/game-stats",
    name: "Game Stats",
    icon: "nc-icon nc-chart-bar-32",
    component: <GameStats />,
    layout: "/admin",
  },
  {
    path: "/game-exports",
    name: "Game Exports",
    icon: "nc-icon nc-cloud-download-93",
    component: <GameExports />,
    layout: "/admin",
  },
  {
    path: "/Qr_code",
    name: "Qr code",
    icon: "nc-icon nc-camera-compact",
    component: <Qr_code />,
    layout: "/admin",

  },
  {
    path: "/WalkThrough",
    name: "Walk Through",
    icon: "nc-icon nc-user-run",
    component: <WalkThrough />,
    layout: "/admin",

  },
  {
    path: "/About",
    name: "About",
    icon: "nc-icon nc-badge",
    component: <About />,
    layout: "/admin",

  },
  {
    path: "/PrivacyPolicies",
    name: "Privacy Policies",
    icon: "nc-icon nc-lock-circle-open",
    component: <PrivacyPolicies />,
    layout: "/admin",

  },
  {
    path: "/Terms",
    name: "Terms",
    icon: "nc-icon nc-paper",
    component: <Terms />,
    layout: "/admin",

  },
  {
    path: "/user-management",
    name: "User Management",
    icon: "nc-icon nc-circle-10",
    component: <Users />,
    layout: "/admin",
  },
  {
    path: "/addUser",
    name: "Add admin",
    icon: "nc-icon nc-single-02",
    component: <Adduser />,
    layout: "/admin",

  },

];

export const getRoutesForRole = (roleValue) => {
  const userRole = normalizeRole(roleValue);

  if (userRole === ROLE_ADMIN) {
    return allRoutes.filter((route) => route.path !== "/addUser");
  }

  if (userRole === ROLE_QUESTION_EDITOR) {
    return allRoutes.filter((route) => route.path === "/questions");
  }

  if (userRole === ROLE_SUPERADMIN || !userRole) {
    return allRoutes;
  }

  return allRoutes;
};

const routes = getRoutesForRole(localStorage.getItem("userRole"));

export default routes;
